import { TicketsWorkspace } from '@/components/TicketsWorkspace';

export function AdminTickets() {
  return <TicketsWorkspace variant="admin" />;
}
